import { types, IModal, ModalActionsType } from '../types/modal'

export const initialState: IModal = {}

export const modal = (state = initialState, action: ModalActionsType) => {
  switch (action.type) {
    case types.MODAL_OPEN:
      return { ...state, id: action.id, options: action.options }
    case types.MODAL_CLOSE:
      return initialState
    default:
      return state
  }
}
